export { default } from './title'
export type { Props as TitleProps } from './title'
